import { render } from "./gameDetailsTab.vue?vue&type=template&id=926657f6&scoped=true"
import script from "./gameDetailsTab.vue?vue&type=script&lang=js"
export * from "./gameDetailsTab.vue?vue&type=script&lang=js"

import "./gameDetailsTab.vue?vue&type=style&index=0&id=926657f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-926657f6"]])

export default __exports__